window.customElements.define("mega-menu", class Megamenu extends HTMLElement {
  megamenuCurrentClass = 'megamenu--current';
  megamenuVisibleClass = 'megamenu--isVisible';
  megamenuAnimateClass = 'megamenu--animate';
  megamenuActiveClass = 'megamenu--active';
  megamenuClosingClass = 'megamenu--closing';
  bodyClass = 'megamenu--isActive';
  megamenuElClass = '[id^="shopify-section-sections"] #megamenu';
  mainNavTarget = 'header .header__menu-item.megamenu-item';
  curtainTarget = 'mega-menu-curtain';
  megamenuEl = null;
  timer = null;
  menuLinkHoverDuration = 100;
  isOpening = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this.addCurtain();
    this.addMeganavToHeader();
    this.updateMegamenuPosition();

    // Event listeners
    this.windowEventScroll();
    this.curtainEventClick();
    this.linkEventMouseout();
    this.curtainEventMouseover();
    this.linkEventClick();
    this.addCloseButtonEvent();
    window.addEventListener('resize', this.updateMegamenuPosition.bind(this));
  }

  updateMegamenuPosition() {
    const headerEl = document.querySelector('.section-header');
    if (!headerEl) return;

    const bottom = Math.round(headerEl.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--megamenu-top', `${bottom}px`);
  }

  disconnectedCallback() {
    if (this.megamenuEl) this.megamenuEl.remove();
  }

  linkEventClick() {
    const self = this;
    document.addEventListener('click', function (e) {
      const menuItem = e.target.closest(self.mainNavTarget);
      if (!menuItem) return;

      const isActive = menuItem.classList.contains(self.megamenuCurrentClass);
      const noSublinks = menuItem.classList.contains('no-sublinks');

      if (!isActive && !noSublinks) {
        e.preventDefault();
        self.showMegamenuItem(menuItem);
      }
    });
  }

  // Methods
  addCurtain() {
    if (document.getElementById('megamenu')) return;
    this.innerHTML = '<mega-menu-curtain></mega-menu-curtain>' + this.innerHTML;
  }

  addMeganavToHeader() {
    document.querySelector('[id^="shopify-section-sections"] .header-wrapper').insertAdjacentHTML('afterend', this.innerHTML)
    this.innerHTML = '';
    this.megamenuEl = document.querySelector(this.megamenuElClass);
  }

  removeAnimation() {
    this.isOpening = false;
    this.megamenuEl.classList.remove(this.megamenuAnimateClass);
    document.body.classList.remove(this.bodyClass);
    document.documentElement.classList.remove("overflow-hidden");
  }

  showMegamenuItem(menuItemEl) {
    if (!menuItemEl) return;

    this.isOpening = true;
    this.updateMegamenuPosition();
    let megamenuId = "megamenu-" + menuItemEl.dataset.title;
    let megamenuItemEl = document.getElementById(megamenuId);

    if (!megamenuItemEl) {
      this.removeAnimation();
      this.hideAllMenuItems();
      clearTimeout(this.timer);
      return;
    }

    this.addLinkEvents(megamenuItemEl);

    // Activate the first panel when megamenu opens
    const firstLink = megamenuItemEl.querySelector('.mega-menu__link--active');
    if (firstLink) {
      this.showMegamenuPanel(firstLink, megamenuItemEl);
    }

    let timerHoverDuration = (this.menuIsVisible()) ? 0 : this.menuLinkHoverDuration;

    let self = this;
    this.timer = setTimeout(() => {
      // prepare menu for animation
      document.body.classList.add(self.bodyClass);
      if (document.body.id !== 'template-cart') {
        document.documentElement.classList.add("overflow-hidden");
      }

      this.megamenuEl.classList.add(self.megamenuAnimateClass);

      // show mega menu item
      setTimeout(() => {
        this.hideAllMenuItems();

        menuItemEl.classList.add(this.megamenuCurrentClass);
        megamenuItemEl.classList.add(this.megamenuVisibleClass);

        let currentMenuItems = this.querySelectorAll('.' + this.megamenuCurrentClass);

        currentMenuItems.forEach(currentMenuItem => {
          currentMenuItem.classList.remove(this.megamenuCurrentClass);
        });

        megamenuItemEl.addEventListener("animationend", event => {
          if (event.animationName !== 'animateMenuFade') return;

          this.megamenuEl.classList.add(this.megamenuActiveClass);
          megamenuItemEl.classList.add(this.megamenuCurrentClass);

          this.isOpening = false;
        });
      }, timerHoverDuration)
    }, timerHoverDuration);
  }

  hideAllMenuItems() {
    // hide mega menu item
    let currentMenuItems = document.querySelectorAll('.' + this.megamenuCurrentClass);
    if (currentMenuItems) {
      for (let i = 0; i < currentMenuItems.length; i++) {
        let currentMenuItem = currentMenuItems[i];
        currentMenuItem.classList.remove(this.megamenuCurrentClass);
        currentMenuItem.classList.add(this.megamenuClosingClass);

        currentMenuItem.addEventListener("animationend", event => {
          if (event.animationName !== 'animateMenuFadeOut') return;

          currentMenuItem.classList.remove(this.megamenuClosingClass);
        });
      }
    }

    let visibleMenuItems = document.querySelectorAll('.' + this.megamenuVisibleClass);

    if (visibleMenuItems) {
      for (let i = 0; i < visibleMenuItems.length; i++) {
        let visibleMenuItem = visibleMenuItems[i];

        visibleMenuItem.classList.remove(this.megamenuVisibleClass);
      }
    }
  }

  menuIsVisible() {
    return !!(document.querySelector('#megamenu.megamenu--animate'));
  }

  // Event Listeners
  addCloseButtonEvent() {
    const buttons = this.megamenuEl.querySelectorAll(".mega-menu__close");

    buttons.forEach(button => {
      button.addEventListener("click", () => {
        this.hideAllMenuItems();
        this.removeAnimation();
      });
    });
  }

  curtainEventClick() {
    const self = this;

    document.addEventListener('click', function (e) {
      if (!e.target.closest(self.curtainTarget)) return false;

      self.hideAllMenuItems();
      self.removeAnimation();
    });
  }

  curtainEventMouseover() {
    const self = this;

    document.addEventListener('mouseover', function (e) {
      if (!e.target.closest(self.curtainTarget)) return false;

      if(self.isOpening) {
        self.isOpening = false;
        return;
      }

      if (!self.menuIsVisible()) return;

      clearTimeout(self.timer);

      self.hideAllMenuItems();
      self.removeAnimation();

      self.megamenuEl.classList.remove(self.megamenuActiveClass);
    });
  }

  windowEventScroll() {
    const self = this;
    window.addEventListener('scroll', function (e) {
      if (self.isOpening) return;

      self.hideAllMenuItems();
      self.removeAnimation();
    })
  }

  linkEventMouseout() {
    const self = this;

    document.addEventListener('mouseout', function (e) {
      if (!e.target.closest(self.mainNavTarget)) return false;

      clearTimeout(self.timer);
      self.lastClickedMenuItem = null;
    });
  }

  addLinkEvents(menu) {
    this.links = menu.querySelectorAll('.mega-menu__link');

    this.links.forEach(link => {
      if (link.dataset.hasClickHandler) return;
      link.dataset.hasClickHandler = 'true';

      link.addEventListener('click', (e) => {
        const isActive = link.classList.contains('mega-menu__link--active');
        const isShopAll = link.classList.contains('mega-menu__link--all');
        const isSubLink = link.classList.contains('mega-menu__link--sub');
        const hasPanel = !!menu.querySelector(`[data-menu="${link.dataset.title}"]`);
        const isParent = link.classList.contains('mega-menu__link--parent') || hasPanel;

        // Keep default navigation for shop-all, nested submenu links, or links with no sub-panels.
        if (isShopAll || isSubLink || !isParent) return;

        // First click on an inactive 2nd-level parent link: switch active state/panel only.
        if (!isActive) {
          e.preventDefault();
        }

        this.setActiveLink(link);
        this.showMegamenuPanel(link, menu);
      });
    });
  }

  setActiveLink(link) {
    this.links.forEach(link => link.classList.remove('mega-menu__link--active'));
    link.classList.add('mega-menu__link--active');
  }

  showMegamenuPanel(link, megaMenuItemEl) {
    const panelHandle = link.dataset.title;
    
    // Hide all panels
    const allPanels = megaMenuItemEl.querySelectorAll('.mega-menu__panel');
    allPanels.forEach(panel => panel.classList.remove('mega-menu__panel--active'));

    // Find and show the matching panel by data-menu attribute
    const targetPanel = megaMenuItemEl.querySelector(`[data-menu="${panelHandle}"]`);
    
    if (targetPanel && targetPanel.classList.contains('mega-menu__panel')) {
      targetPanel.classList.add('mega-menu__panel--active');
    }
  }
})

